/**
 * @generated SignedSource<<42bb702f99e33961b83488182523f867>>
 * @relayHash 5333799c2e40ea79289e1a1f102ce431
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/CheckoutPhoneLinkRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPhoneLinkRefetchQuery$variables = {
  hasTradeStatus: boolean;
};
export type CheckoutPhoneLinkRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"CheckoutPhoneLink_viewer">;
  };
};
export type CheckoutPhoneLinkRefetchQuery = {
  response: CheckoutPhoneLinkRefetchQuery$data;
  variables: CheckoutPhoneLinkRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasTradeStatus"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "INTERNATIONAL"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckoutPhoneLinkRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CheckoutPhoneLink_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckoutPhoneLinkRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactInfo",
            "kind": "LinkedField",
            "name": "contactInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "support",
                "kind": "LinkedField",
                "name": "phoneNumbers",
                "plural": false,
                "selections": [
                  {
                    "condition": "hasTradeStatus",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": "intlSupport",
                        "args": (v1/*: any*/),
                        "kind": "ScalarField",
                        "name": "support",
                        "storageKey": "support(formatType:\"INTERNATIONAL\")"
                      },
                      {
                        "alias": "defaultSupport",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "support",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "hasTradeStatus",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v1/*: any*/),
                        "kind": "ScalarField",
                        "name": "tradeSupport",
                        "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                      },
                      {
                        "alias": "defaultTradeSupport",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tradeSupport",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/CheckoutPhoneLinkRefetchQuery",
    "metadata": {},
    "name": "CheckoutPhoneLinkRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6ad7f6d0700e7ad07f581849f839bb51";

export default node;
